import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class DecreaseIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8"><path fillRule="evenodd" d="M.502 0h8.996a.502.502 0 0 1 .422.773L5.422 7.77a.502.502 0 0 1-.844 0L.08.773A.502.502 0 0 1 .502 0z"/></svg>
        )
    }
}

export default withCssClassName(DecreaseIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/decrease-icon.js